import { addWorks } from "@/api/OmdWorks/works";
import store from "../store";
import { listCourses } from "@/api/OmdCourses/courses";
import { getToseck } from "@/utils/toseck";
import { listMajors } from "@/api/OmdMajors/majors";
import { getUserProfile } from "@/api/system/user";
export default {
  data() {
    return {
      form: {
        courseId: null, // 显式声明课程ID属性，初始值为null
        majorId: null,  // 专业ID也建议显式声明
        xueQi: '',    // 学期属性
       workTitle: '',  // 作品名称
       sortNum: null,//排序序号
       creationDate:null,
       updateDate:null,
       workScreatetime:null,
       workUpdateTime:null,
       workMedia:'',
       stage:'',
       

      },
      courseForm: [],
      majorForm: [],
      uploadImgUrl : process.env.VUE_APP_BASE_API + "/common/upload",
      headers:{
        'Authorization': 'Bearer ' + getToseck()
      },
      formLabelWidth: "120px",
      rules: {
       
        workScreatetime: [
          { required: true, message: "请输入创建日期", trigger: "change" },
        ],
         xueQi: [
          { required: true, message: "请选择学期", trigger: "change" },
        ],
       
        workTitle: [
          { required: true, message: "请输入作品名称", trigger: "blur" },
        ],
     
        workMedia: [
           { required: true, message: "请上传作品图片",trigger: "change" },
        ],
         majorId: [
          { required: true, message: "请选择专业" ,trigger:"change"},
        ],
         stage: [
          { required: true, message: "请选择所属学期阶段",trigger:"change" },
        ],
      },
      imageUrl: "",
      previousImageUrl: null,
    };
  },
  computed: {
    dialogFormVisible() {
      return this.$store.state.dialogFormVisible;
    },
  },
  created() {
     this.setMajor();
    //  this.setcourses();
   //this.setWorks();
   this.getProfileInfo();
  
  },
  methods: {
     // 当专业选择变化时触发
  onMajorChange(majorId) {
    // 清空旧的课程数据和选择
    this.courseForm = [];
    this.form.courseId = null;
    
    // 如果选择了专业，则加载对应课程
    if (majorId) {
      this.setcourses(majorId);  // 调用已有方法，传递专业ID
    }
  },
    // 直接在组件内调用getProfile接口
        async getProfileInfo() {
            try {
                const res = await getUserProfile(); // 调用接口获取资料
                if (res.code === 200) {

                    // 2. 从接口返回结果中提取majorId
                    this.form.majorId = res.major.majorId;
                    
                }
            } catch (err) {
                console.error('获取专业ID失败', err);
            }
        },
    handleCloseDialog() {
       // 释放图片资源（关键）
      if (this.imageUrl) {
        URL.revokeObjectURL(this.imageUrl);
        this.imageUrl = "";
      }
      // 重置表单和状态
      this.$refs.form.resetFields();
      store.commit("setDialogFormVisible", false);
      store.commit("page/setPage", "works");
      
    },
    setcourses(majorId) {
      listCourses({majorId:majorId}).then((res) => {
        if (res.code === 200) {
          console.log(res)
          this.courseForm = res.rows;
        }
      })
    },
    setMajor() {
      
      listMajors().then((res) => {
        if (res.code === 200) {
          console.log(res)
          this.majorForm = res.rows;
        }
      })
    },
    setPage() {
       // 关闭时释放资源
      if (this.imageUrl) {
        URL.revokeObjectURL(this.imageUrl);
        this.imageUrl = "";
      }
       store.commit("setDialogFormVisible", false);
      store.commit("page/setPage", "works");
    },

   

    setPahe1() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          
          addWorks(this.form).then((res) => {
            console.log(this.form)
            console.log(res)
            if (res.code === 200) {
              this.$message({
                message: "上传成功",
                type: "success",
              });
              // 成功后关闭并释放资源
                this.handleCloseDialog();
              store.commit("setDialogFormVisible",false);
              store.commit("page/setPage", "works");
             
            } else {
              this.$message({
                message: "上传失败",
                type: "error",
              });
            }
          }).catch((err) => {
            console.log(err);
           }) ;
          
        } else {
          this.$message.error("请完善信息");
        }
      });
    },

    handleAvatarSuccess(res, file) {
        if (this.imageUrl) {
        URL.revokeObjectURL(this.imageUrl);
      }
      if (this.previousImageUrl) {
        URL.revokeObjectURL(this.previousImageUrl);
      }
      try {
        // 生成上传图片的 URL
        this.imageUrl = URL.createObjectURL(file.raw);
        //console.log("鹿鹿1：this.imageUrl地址"+this.imageUrl);

        this.form.workMedia = res.url;//https://xhsa1.openapi.xiaohai2006.cn:86/profile/upload/2025/06/18/bb31513619ca7ad_20250618205831A004.jpg
       // console.log("鹿鹿2：this.form.workMedia地址"+res.url);
        this.previousImageUrl = this.imageUrl;
        // console.log("鹿鹿3： this.previousImageUrl"+ this.previousImageUrl);
      } catch (error) {
        console.error("创建图片 URL 时出错:", error);
        this.$message.error("图片处理出错，请重试！");
         // 重置状态
        this.imageUrl = "";
        this.form.workMedia = "";
      }
    },

    handleUploadError(error) {
      console.error("上传图片时出错:", error);
      this.$message.error("图片上传出错，请重试！");
      // 重置状态
      this.imageUrl = "";
      this.form.workMedia = "";
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
  },
  beforeDestroy() {
    if (this.previousImageUrl) {
      URL.revokeObjectURL(this.previousImageUrl);
    }
     if (this.imageUrl) {
      URL.revokeObjectURL(this.imageUrl);
    }
  },
};